export default __webpack_public_path__ + "static/media/regulatory--no-heavy-goods-vehicles-or-tractors--g1.a3d74207.png";